
























































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import Room from "../../../store/entities/room";
import AppConsts from "../../../lib/appconst";
import util from "../../../lib/util";
import DateTimeMixin from '@/components/mixin/date-time-mixin';
import { mixins } from 'vue-class-component';
@Component
export default class ViewRoom extends mixins(DateTimeMixin, AbpBase)  {
  @Prop({ type: Boolean, default: false }) value: boolean;
  room: Room = new Room();
  spinShow = false;
  id: string ='';
   onGoBack(){
      (this.$refs.roomForm as any).resetFields();
      this.$emit("input", false);
      this.$root.$router.push({name: 'room'});
  }
   async getRoomInfo()
  {
       this.id =  this.$root.$router.currentRoute.params.id;
      if(Util.isNull(this.id) || Util.isEmpty(this.id) )
        return;
      await this.$store.dispatch({
          type:'room/get',
          data: { id : this.id}
      }).then((result) => {
          this.room = result;
      });
  }
  async created(){
      await this.getRoomInfo();
  }
}
